export const ALL_TRAFFIC = {
  name: 'All Traffic',
  rule: [],
  rule_text: '(All Traffic)',
};

export const LIVE_TRAFFIC = {
  name: 'Live Traffic',
  rule: [
    [
      {
        field: 'c3.video.isLive',
        value: 'T',
        display: 'Live Traffic',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Content Category EQUALS Live)',
};

export const VOD_TRAFFIC = {
  name: 'VOD Traffic',
  rule: [
    [
      {
        field: 'c3.video.isLive',
        value: 'F',
        display: 'VOD Traffic',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Content Category EQUALS VoD)',
};

export const WEB_PLATFORM = {
  name: 'Web Platform',
  rule: [
    [
      {
        field: 'platform',
        value: 'web',
        display: 'web',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Platform EQUALS web)',
};

export const MOB_PLATFORM = {
  name: 'Mobile Platform',
  rule: [
    [
      {
        field: 'platform',
        value: 'mob',
        display: 'mob',
        key: null,
        op: 'eq',
      },
    ],
  ],
  rule_text: '(Platform EQUALS mob)',
};
